export enum PaymentCategorySystem {
    NEWSANDACCESS = 'news and access',
    PERFORMANCE = 'performance',
    RESOURCE = 'resource'
}



// WEBPACK FOOTER //
// ./js/utils/types/payment_categories.ts